import { Component, ViewChild, OnInit, Inject, HostListener } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { PrimeNGConfig } from 'primeng/api';
import { Globals } from 'src/app/globals';
import { Meta } from '@angular/platform-browser';
import { AppEventMessagesService } from './services/application-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Portal';

  constructor(
    private swUpdate: SwUpdate,
    private primengConfig: PrimeNGConfig,
    public globals: Globals,
    private meta: Meta,
    private appEventMessagesService: AppEventMessagesService
  ) {
  }


  @HostListener('window: unload', [ '$event'])
  unloadHandler(event) {
    // …
    console.log("On Unload");
  }
  @HostListener('window: beforeunload', [ '$event'])
  beforeUnloadHandler(event) {
    // …
    console.log("Before Unload");
    //alert("Before Unload");
  }


  apiValues: string[] = [];
  showMenu = false;
  darkModeActive: boolean;

  toggleMenu() {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.available.subscribe((evt) => {
                console.log('service worker updated');
            });
    
            this.swUpdate.checkForUpdate().then(() => {

            }).catch((err) => {
                console.error('error when checking for update', err);
            });
    }
  }
  
  modeToggleSwitch() {

  }

  ngOnInit() {

    this.primengConfig.zIndex = {
      modal: 1100,    // dialog, sidebar
      overlay: 9999,  // dropdown, overlaypanel
      menu: 1300,     // overlay menus
      tooltip: 1100   // tooltip
    };


    //DECLARE CSS VARIABLES
    document.documentElement.style.setProperty('--sideNavBackground', this.globals.brandColor_SideNav);
    document.documentElement.style.setProperty('--sideNavBackground_Hover', this.globals.brandColor_SideNav_Hover);

    document.documentElement.style.setProperty('--primaryColor', this.globals.brandColor_Qualus);
    document.documentElement.style.setProperty('--primaryColor_Hover', this.globals.brandColor_Qualus_Hover);

    if (this.globals.useCustomHeaderVariable) {
      document.documentElement.style.setProperty('--customHeaderBackground', this.globals.brandColor_Custom_Header);
    } else {
      document.documentElement.style.setProperty('--customHeaderBackground', this.globals.brandColor_Qualus);
    }

    document.documentElement.style.setProperty('--primaryColorBackground_Accordion', this.globals.primaryColorBackground_Accordion);
    document.documentElement.style.setProperty('--primaryColorText_Accordion', this.globals.primaryColorText_Accordion);

    document.documentElement.style.setProperty('--homeModule_Background', this.globals.homeModule_Background);
    document.documentElement.style.setProperty('--homeModule_Background_Hover', this.globals.homeModule_Background_Hover);
    document.documentElement.style.setProperty('--homeModule_Border_Hover', this.globals.homeModule_Border_Hover);

    this.meta.updateTag({ name: 'theme-color', content: this.globals.brandColor_Qualus });
    //INITIALIZE EveneMessage Listner
    this.appEventMessagesService.initEventMessagesListener();
    //INITALIZE ReSync Listener
    this.appEventMessagesService.registerNetworkSync();
  }

}

export class project {
  public id: string;
 constructor(private swUpdate: SwUpdate) {}

  public value: string;
}

export class employee {
  constructor(
  ) { }
  public id: string;
  public value: string;
}

declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Array<Provider | EnvironmentProviders>;
  }
}
